export const DEFAULT_PAGE_SIZE = 3;

export const START_PAGINATION_PAGE = 1;


export const proposalOverviewColumns = (t) => [
    {
        key: 'proposalId',
        title: t('dashboard.proposalOverview.proposalId'),
    },
    {
        key: 'product',
        title: t('dashboard.agentCockpit.productWorld'),
    },
    {
        key: 'createdDate',
        title: t('dashboard.agentCockpit.createdDate'),
    },
    {
        key: 'advisor',
        title: t('dashboard.overviewClientApplications.advisor'),
    },
    {
        key: 'proposalDetails',
        title: '',
    },
];
